import React from "react"

import HomeUI from "../../ui/homeUI/_index";

const NormalStaff = () => {
  return (
    <HomeUI />
  )
}

export default NormalStaff